// components/settings/GeneralSettings.jsx
import React, { useState, useEffect } from 'react';
import { Moon, Sun, Save } from 'lucide-react';

const GeneralSettings = () => {
    const [settings, setSettings] = useState({
        theme: 'light',  // or 'dark', 'system'
        // Can add more general settings here
    });

    useEffect(() => {
        // Load settings from localStorage
        const loadedSettings = localStorage.getItem('generalSettings');
        if (loadedSettings) {
            setSettings(JSON.parse(loadedSettings));
        }
    }, []);

    const handleThemeChange = (theme) => {
        setSettings(prev => ({ ...prev, theme }));
        // Apply theme change immediately
        document.documentElement.className = theme;
    };

    const handleSave = () => {
        localStorage.setItem('generalSettings', JSON.stringify(settings));
        // Could also send to backend if needed
    };

    return (
        <div className="space-y-6">
            <div>
                <h3 className="text-lg font-medium mb-4">General Settings</h3>

                {/* Theme Selection */}
                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Theme
                    </label>
                    <div className="flex gap-4">
                        <button
                            onClick={() => handleThemeChange('light')}
                            className={`flex items-center gap-2 px-4 py-2 rounded-lg ${
                                settings.theme === 'light' 
                                    ? 'bg-blue-100 text-blue-700' 
                                    : 'bg-gray-100 text-gray-700'
                            }`}
                        >
                            <Sun className="w-4 h-4" />
                            Light
                        </button>
                        <button
                            onClick={() => handleThemeChange('dark')}
                            className={`flex items-center gap-2 px-4 py-2 rounded-lg ${
                                settings.theme === 'dark' 
                                    ? 'bg-blue-100 text-blue-700' 
                                    : 'bg-gray-100 text-gray-700'
                            }`}
                        >
                            <Moon className="w-4 h-4" />
                            Dark
                        </button>
                        <button
                            onClick={() => handleThemeChange('system')}
                            className={`flex items-center gap-2 px-4 py-2 rounded-lg ${
                                settings.theme === 'system' 
                                    ? 'bg-blue-100 text-blue-700' 
                                    : 'bg-gray-100 text-gray-700'
                            }`}
                        >
                            System
                        </button>
                    </div>
                </div>

                {/* Save Button */}
                <button
                    onClick={handleSave}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                    <Save className="w-4 h-4" />
                    Save Settings
                </button>
            </div>
        </div>
    );
};

export default GeneralSettings;